import React from 'react';

interface LogoProps {
  showImage?: boolean;
  showText?: boolean;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  showImage = true, 
  showText = false, 
  className = '' 
}) => {
  return (
    <div className={`logo ${className}`}>
      {showImage && (
        <img 
          src="/VolunteerHeart.png" 
          alt="FabMo Volunteer" 
          className="logo-image" 
        />
      )}
      {showText && (
        <span className="logo-text">FabMo</span>
      )}
    </div>
  );
};

export default Logo;
